/**
 * 切换 Region 成功后的 Web 运行时上下文同步与首页整页刷新。
 *
 * 供 choose_location_page、change_region_popup 复用：
 * - syncRegionRuntimeTags：入口 mainIndex 仅在启动时设置一次 H5guard/LXAnalytics/owl，
 *   切区后需同步更新（整页刷新前的窗口期）；
 * - redirectToHomeAfterRegionChange：重置接口预取缓存后整页跳转 /mpweb 并携带
 *   region/cityId 参数，入口 index.ejs 以 URL query 为权威重新初始化运行时 Region 上下文。
 */
import { resetPrefetchCache } from '@m2h/common/request/apiPrefetcher';

/**
 * 切换 Region 后同步 Web 运行时上下文：
 * H5guard 防护标记、LXAnalytics Compass、owl 监控 tag
 */
export const syncRegionRuntimeTags = (selectedCity) => {
  const { region, cityId } = selectedCity || {};
  if (!region) {
    return;
  }
  window.H5guard?.setRegion?.(region);
  window.LXAnalytics?.('setCompass', JSON.stringify({ region, cityId }));
  window.owl?.('setTag', {
    area: region,
    cityId,
  });
};

/**
 * 切换 Region 成功后整页跳转首页，携带 region、cityId 参数，
 * 由入口 index.ejs 以 query 为权威重新初始化运行时 Region 上下文。
 * 调用方可能运行在 alertIframe 弹窗中：先关闭顶层弹窗完成清理，再刷新顶层页面。
 */
export const redirectToHomeAfterRegionChange = (selectedCity) => {
  const { region, cityId } = selectedCity || {};
  if (!region) {
    return;
  }
  const homeUrl = `/mpweb?region=${encodeURIComponent(region)}${
    cityId !== undefined && cityId !== null && String(cityId).trim() !== ''
      ? `&cityId=${encodeURIComponent(cityId)}`
      : ''
  }`;
  let topWindow: any = window;
  let inIframe = false;
  try {
    if (window.self !== window.top) {
      topWindow = window.top;
      inIframe = true;
    }
  } catch (e) {
    // 跨域无法读取 top 时退回当前窗口跳转。
  }
  console.log(123);
  if (inIframe && topWindow) {
    // topWindow.alertIframeManager?.close?.();
  }
  // 旧 Region 的接口预取缓存全部失效，跳转前重置，避免刷新窗口期命中旧数据
  resetPrefetchCache();
  topWindow.location.href = homeUrl;
};
